export const stringNormalize = (value: string) => {
  return value.toLowerCase().replace(/\s+/g, "");
};
